import {
  type FetchProductNameQuery,
  type FetchProductNameQueryVariables,
  FetchProductNameDocument,
} from 'domains/merchandising/api'
import { useMeshQuery } from 'legacy/apollo/clientHooks'

interface FetchProductNameMeshArgs {
  productId: string
}

export const useGetQueryProductName = ({ productId }: FetchProductNameMeshArgs) => {
  const variables = {
    productId,
  }

  const { data, error, loading } = useMeshQuery<
    FetchProductNameQuery,
    FetchProductNameQueryVariables
  >(FetchProductNameDocument, {
    fetchPolicy: 'cache-and-network',
    variables,
  })

  const products = data?.catalogProducts

  return {
    apiResult: products && products.length === 1 && products[0].displayName,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiError: error,
  }
}
